import { useEffect } from 'react';
import { usePreproductPreviewContext } from '../context/Context';
import { PREPROD_PREVIEW_ACTIONS } from '../context/types';
export var useIframeReady = function useIframeReady() {
  var _usePreproductPreview = usePreproductPreviewContext(),
      dispatch = _usePreproductPreview.dispatch;

  useEffect(function () {
    var onMessage = function onMessage(event) {
      if (event.data.type === 'PREPROD_READY') {
        dispatch({
          type: PREPROD_PREVIEW_ACTIONS.SET_IFRAME_READY,
          payload: true
        });
      }
    };

    window.addEventListener('message', onMessage);
    return function () {
      return window.removeEventListener('message', onMessage);
    };
  }, [dispatch]);
};